// Resolver adapter helpers for compile-time `.luis` import inlining.
// Supports resolver outputs as raw source string or `{ id, source }` object.
import type { LuisResolvedImport } from '../types'

// Normalize resolver return payload into `{ id, source }` shape.
export function normalizeResolvedImport(
  request: string,
  resolved: string | LuisResolvedImport,
): LuisResolvedImport {
  // Check whether the resolver returned a plain source string.
  if (typeof resolved === 'string') {
    // Return wrapped plain-string outputs with the request-based source id.
    return {
      id: request,
      source: resolved,
    }
  } else {
    // Keep explicit resolver payload unchanged.
    return resolved
  }
}

// Build stable source id fallback when caller does not provide one.
export function resolveSourceId(sourceId: string | undefined, fallback: string): string {
  // Check whether the caller already provided a stable source id.
  if (sourceId && sourceId.trim().length > 0) {
    // Return the caller-provided source id when available.
    return sourceId
  } else {
    // Return fallback id for anonymous inline sources.
    return fallback
  }
}
